import ServiceListPage from "./pages/ServiceListPage";
import ServiceCreatePage from "./pages/ServiceCreatePage";
import ServiceDetailPage from "./pages/ServiceDetailPage";
import ServiceUnavailableDatePage from "./pages/ServiceUnavailableDatePage";
import MultipleServiceUnavailableDatePage from "./pages/MultipleServiceUnavailableDatePage";

export const serviceRoutes = (prefix = "services") => [
  {
    name: "ServiceCreatePage",
    path: `${prefix}/create`,
    component: ServiceCreatePage
  },
  {
    name: "ServiceUnavailableDatePage",
    path: `${prefix}/:id/unavailable-date`,
    component: ServiceUnavailableDatePage
  },
  {
    name: "MultipleServiceUnavailableDatePage",
    path: `${prefix}/multiple-unavailable-date`,
    component: MultipleServiceUnavailableDatePage
  },
  {
    name: "ServiceDetailPage",
    path: `${prefix}/:id`,
    component: ServiceDetailPage
  },
  { name: "ServiceListPage", path: prefix, component: ServiceListPage }
];



// WEBPACK FOOTER //
// ./src/features/subscriptions/modules/services/routes.js